export default __webpack_public_path__ + "static/media/Armbands of the Huntmaster.dae3f934.jpg";